import { render, staticRenderFns } from "./SelectCheckBoxInput.vue?vue&type=template&id=65546258&scoped=true&"
import script from "./SelectCheckBoxInput.vue?vue&type=script&lang=js&"
export * from "./SelectCheckBoxInput.vue?vue&type=script&lang=js&"
import style0 from "./SelectCheckBoxInput.vue?vue&type=style&index=0&id=65546258&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65546258",
  null
  
)

export default component.exports